import React, { useState, useEffect, useContext } from "react";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import InputBase from "@mui/material/InputBase";

import SearchIcon from "@mui/icons-material/Search";

import LibraryContext from "../libraryContext";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.default,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 1),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 5),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
  },
}));

export default function SearchBar() {
  const { t } = useTranslation();
  const searchText = t("common.search");
  const { query, handleQuery } = useContext(LibraryContext);
  const [input, setInput] = useState("");

  const handleChange = (event) => {
    setInput(event.target.value);
  };

  useEffect(() => {
    // clear the searchbar input when naviagting
    if (query.q === "") setInput("");
  }, [query]);

  useEffect(() => {
    const timeoutId = setTimeout(
      () => handleQuery({ type: "search", payload: input }),
      400
    );
    return () => clearTimeout(timeoutId);
  }, [input]);

  return (
    <Box width={"100%"}>
      <Search>
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <StyledInputBase
          value={input}
          onChange={handleChange}
          onSubmit={(event) => event.preventDefault()}
          placeholder={searchText}
          fullWidth
        />
      </Search>
    </Box>
  );
}
